import React, {FC} from 'react';

import classNames from 'classnames';

import {Feature, FeatureWithAnalytics} from 'components/feature';
import {REFERER_OFFER} from 'constants/analytics/mentionMe';
import {MentionMeBannerV2} from 'desktop/components/mentionMe/mentionMeBannerV2/mentionMeBannerV2';
import {useCheckLuxuryItem} from 'hooks/useCheckLuxuryItem/useCheckLuxuryItem';
import {flags} from 'libs/rollout';

import {OrderDetails} from '../../componentsV2/orderDetails/orderDetails';

import {OneTimeCouponOffer} from '../oneTimeCouponOffer/oneTimeCouponOffer';
import {SuccessPageBottomSection} from '../successPageBottomSection/successPageBottomSection';
import {SuccessPageRewardsBannerV2} from '../successPageRewardsBanner/successPageRewardsBannerV2/successPageRewardsBannerV2';

import {SuccessHeader} from './successHeader/successHeader';

import s from './successPageRedesign.scss';

export type PropsType = {
    shipmentInfo: string;
};

/**
 * TYP Redesigned Glasses
 */
export const SuccessPageRedesign: FC<PropsType> = ({shipmentInfo}) => {
    const isLuxuryEnabled = useCheckLuxuryItem(flags.dLuxurySpecialExperience.isEnabled());

    return (
        <>
            <div className={classNames(s.container, s.mainSectionContainer)}>
                <section className={s.mainSection}>
                    <div className={s.leftPart}>
                        <SuccessHeader shipmentInfo={shipmentInfo} />
                        <div className={s.detailsWrapper}>
                            <OrderDetails isGlassesTYP />
                            <FeatureWithAnalytics
                                flag="dTypOneTimeCoupon"
                                isInteraction={false}
                                platform="desktop"
                            >
                                <OneTimeCouponOffer />
                            </FeatureWithAnalytics>
                        </div>
                    </div>
                    <div className={s.rightPart}>
                        {!isLuxuryEnabled && <SuccessPageRewardsBannerV2 />}
                        <Feature flag="typMentionMeBanner" platform="desktop">
                            <MentionMeBannerV2
                                params={{
                                    implementation: 'popup',
                                    locale: 'en_GB',
                                    situation: 'postpurchase',
                                }}
                                integratingType={REFERER_OFFER}
                            />
                        </Feature>
                    </div>
                </section>
            </div>
            <div className={classNames(s.container, s.bottomSectionContainer)}>
                <SuccessPageBottomSection />
            </div>
        </>
    );
};
